import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import * as R from 'ramda';
import moment from 'moment';
import toast from '~~elements/Toast';
import Button from '~~elements/Button';
import { CPBLResource } from '~~apis/resource';
import { GameSectionDiv } from '../styled';

const StyledDiv = styled.div`
  width: 100%;
  table {
    width: 100%;
    tr {
      border-bottom: 1px solid gray;
    }
  }
`;

// 只有 Rebas 管理員 + CPBL 才能使用
const CPBLMergeSection = ({ organizer }) => {
  const [players, setPlayers] = useState([]);

  const [selectedMainIndex, setSelectedMainIndex] = useState(-1);
  const [selectedSubIndexes, setSelectedSubIndexes] = useState([]);

  useEffect(() => {
    CPBLResource.listAllPlayer({ uniqid: organizer.uniqid }).then(({ data }) => {
      const mapping = R.groupBy(R.prop('name'), data);
      const nonDuplicatedPlayers = [];
      const nameDuplicatedPlayers = [];
      Object.values(mapping).forEach((players) => {
        if (players.length === 1) {
          nonDuplicatedPlayers.push(...players);
          return;
        }
        nameDuplicatedPlayers.push(...players);
        return;
      });
      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
      const sortedDuplicatedPlayers = sortByNameCaseInsensitive(nameDuplicatedPlayers);
      const sortedPlayers = sortByNameCaseInsensitive(nonDuplicatedPlayers);
      console.log(sortedDuplicatedPlayers);
      console.log(sortedPlayers);
      setPlayers([...sortedDuplicatedPlayers, ...sortedPlayers]);
    });
  }, [organizer]);

  const handleMerge = () => {
    const mainUniqid = players[selectedMainIndex].uniqid;
    const subUniqids = selectedSubIndexes.map((i) => players[i].uniqid);
    CPBLResource.mergePlayer({ mainUniqid, subUniqids })
      .then(() => {
        toast('合併成功，可稍候重新整理確認', { status: 'success', second: 1 });
      })
      .catch((e) => {
        toast('無法合併（球員名稱不相同），請重整重新嘗試', { status: 'error', second: 2 });
      });

    const leftPlayers = [];
    players.forEach((p, i) => {
      if (i === selectedMainIndex || selectedSubIndexes.includes(i)) {
        return;
      }
      leftPlayers.push(p);
    });
    setSelectedMainIndex(-1);
    setSelectedSubIndexes([]);
    setPlayers(leftPlayers);
  };

  return (
    <GameSectionDiv>
      <h3 className="section--title">Rebas 管理員專用</h3>
      <StyledDiv>
        <table>
          <thead>
            <tr>
              <th>主要</th>
              <th>合併</th>
              <th>名稱</th>
              <th>生日</th>
              <th>慣用手</th>
              <th>經驗</th>
            </tr>
          </thead>
          <tbody>
            {players.map((player, index) => (
              <tr
                key={player.uniqid}
                style={{
                  backgroundColor: players.filter((p) => p.name === player.name).length > 1 ? 'orange' : 'inherit',
                }}
              >
                <td>
                  <input
                    type="radio"
                    name="main"
                    onChange={(e) => {
                      setSelectedMainIndex(index);
                      setSelectedSubIndexes([]);
                    }}
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    name="sub"
                    onChange={(e) =>
                      selectedSubIndexes.includes(index)
                        ? setSelectedSubIndexes(R.filter((i) => i !== index, selectedSubIndexes))
                        : setSelectedSubIndexes([...selectedSubIndexes, index])
                    }
                    checked={selectedSubIndexes.includes(index)}
                    disabled={selectedMainIndex === index}
                  />
                </td>
                <td style={{ backgroundColor: selectedMainIndex === index ? 'yellow' : 'unset' }}>
                  {player.name}
                  <br />
                  {player.uniqid}
                  {
                    <>
                      <br />
                      {selectedMainIndex === index && (
                        <Button color="red" mini disabled={selectedSubIndexes.length === 0} onClick={handleMerge}>
                          合併
                        </Button>
                      )}
                    </>
                  }
                </td>
                <td>{moment(player.birthday).format('YYYY-MM-DD')}</td>
                <td>{`${player.p_hand}投/${player.b_hand}打`}</td>
                <td>
                  {player.experiences.map((exp) => (
                    <>
                      {`${exp.season} ${exp.team}`}
                      <br />
                    </>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </StyledDiv>
    </GameSectionDiv>
  );
};

export default CPBLMergeSection;
